import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Login } from "./pages/login";
import { Resetpassword, Resetpasswordsuccess } from "./pages/resetpassword";
import { Layout } from "./layouts/layout";
import { EmpPermission, EmpManagePermission } from "pages/employee/permission";
import { Emp, EmpCreate } from "pages/employee/emp";
import { Distributor, DistributorGroup } from "pages/distributor/distributor";
import { DistributorCreate } from "pages/distributor/distributorCreate";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import GlobalLoader from "layouts/GlobalLoader";
import { Routes, Route } from "react-router-dom";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import GlobalModal from "layouts/GlobalModal";
import ProtectedRoutes from "router/protected.routes";
import PublicRoutes from "router/public.routes";
import { VER, domain } from "constants/server/api";
import NotFoundPage from "pages/NotFoundPage";
import { PRList } from "pages/purchase/requisitionDatalist";
import { PRCreate } from "pages/purchase/requisition";
import { POList } from "pages/purchase/orderDatalist";
import { POCreate } from "pages/purchase/Order";
import { PRPrint } from "layouts/PrintPR";
import { POPrint } from "layouts/PrintPO";
import { useReactToPrint } from "react-to-print";
import { GRList } from "pages/goodsreceipt/GoodsReceiptDatalist";
import { GoodsReceipt } from "pages/goodsreceipt/GoodsReceipt";
import { CreditorList } from "pages/financial/creditors/datalist";
import { CheckGoodsReceipt } from "pages/financial/creditors/GoodsReceipt";
import { env } from "env";
import { GRPrint } from "layouts/PrintGR";
import { testData } from "mocks/printGrData";
import { ReportBuySupplier } from "pages/report/buy/supplier";
import { ReportBuyOrder } from "pages/report/buy/order";
import { ReportBuyPoItem } from "pages/report/buy/poItem";
import { ReportBuyGrItem } from "pages/report/buy/grItem";
import { ReportMaps } from "pages/report/maps";
import { ReportAppointment } from "pages/report/appointment";
import { ExpenseList } from "pages/financial/expense/datalist";
import { ExpenseCreate } from "pages/financial/expense/expense";
import { ReportGrItemExpense } from "pages/report/buy/grItemWithExpense";
import { ManagePartner } from "pages/manage/partner";
import { ManagePartnerView } from "pages/manage/partnerView";
import { ManageProducts } from "pages/manage/products";
import { ManageProductsDatalist, ManageProductsView } from "pages/manage/productsView";
import { ContractNew } from "pages/contract/contractNew";
import { ContractNewCreate } from "pages/contract/contractNewCreate";
import { ContractAttach } from "pages/contract/contractAttach";
import { Quotation } from "pages/quotation/quotation";
import { QuotationCreate, QuotationByContract } from "pages/quotation/quotationCreate";
import { Billing, BillingCreate } from "pages/manage/billing";
import { Invoice, InvoiceManage } from "pages/manage/invoice";
import { Branch, BranchManage } from "pages/manage/branch";
import { Promotion, PromotionManage } from "pages/manage/promotion";
import { Catalog, CatalogManage, CatalogAction } from "pages/manage/catalog";
import { ClBook } from "pages/manage/clbook";
import { StockCountList, StockCountEdit } from "pages/manage/stockCount";
import { Shop, ShopManage, ShopManageDatalist } from "pages/manage/shop";
import ShopProductBan from "pages/manage/shopProductBan";
import ShopSpecialPrice from "pages/manage/shopSpecialPrice";
import { Brand } from "pages/manage/brand";
import { ImportContacts, Settings } from "@mui/icons-material";
import { SetUser, SetUserManage } from "pages/manage/setuser";
import { SettingsMaster } from "pages/setting/settingsMaster";
import { Permission } from "pages/setting/permission/permission";
import { PermissionCreate } from "pages/setting/permission/permissionCreate";
import { ReportReservation, ReportReservationWaitDelivery, ReservationManagement } from "pages/report/reportReservation";
import { ProductCheck } from "pages/report/productCheck";
import { ManageReservation, ViewReservation } from "pages/report/reportReservationManage";
import { ProductList, ProductUpdate } from "pages/manage/productlist";
import { ShopVisitList, ShopVisitManage } from "pages/manage/shopvisit";
import { ReportPurchaseByBrand, ReportPurchaseByBrandDetail, ReportPurchasePendingConfirm } from "pages/report/reportPurchaseByBrand";
import { ReportPurchaseByProduct } from "pages/report/reportPurchaseByProduct";
import { ReportReservationBySku } from "pages/report/reportReservationBySku";
import { ReportReservationPerformanceMonthly } from "pages/report/reportReservationPerformanceMonthly";
import { ReportReservationWorkTracking } from "pages/report/reportReservationWorkTracking";
import { ReportSkuActualDeliveryMonthly, ReportSkuActualDeliveryMonthlyByShop, ReportSkuGiftMonthly } from "pages/report/reportSkuActualDeliveryMonthly";
import { ReportReservationDuration } from "pages/report/reportReservationDuration";
import { ReportSalesNewStore, ReportSalesNewStoreDetail } from "pages/report/reportSalesNewStore";
import { ReportPartner } from "pages/report/reportPartner";
import { ReportSku } from "pages/report/reportSku";
import { ReportReserve } from "pages/report/reportReserve";
import { ReportReserveDay } from "pages/report/reportReserveDay";
import { ReportSkuDay } from "pages/report/reportSkuDay";
import { ReportPartnerDay } from "pages/report/reportPartnerDay";
import { ReportSaleVisitAndReserve } from "pages/report/reportSaleVisitAndReserve";
import { ReportSaleVisitAndReserveBySale } from "pages/report/reportSaleVisitAndReserveBySale";
import { ReportSaleIntendantBranch } from "pages/report/reportSaleIntendantBranch";
import { ReportStoreVisitAppointment, ReportStoreVisitAppointmentDetail } from "pages/report/reportStoreVisitAppointment";
import { ReportBrandSummary } from "pages/report/reportBrandSummary";
import { Dashboard } from "pages/dashboard";
import { ImportInvoiceMt, ImportInvoiceTt } from "pages/manage/importInvoice";
import { ImportProductsMt, ImportProductsTt } from "pages/manage/importProduct";
import { ReportSalesByStoreMt, ReportSalesByStoreTt } from "pages/report/reportSalesByStore";
import { ReportSalesByProductMt, ReportSalesByProductTt } from "pages/report/reportSalesByProduct";
import { ReportReserveProductSummary } from "pages/report/reportReserveProductSummary";
import { ReportProductNotReadyDelivery } from "pages/report/reportProductNotReadyDelivery";
import { ReportShippingCostAudit } from "pages/report/reportShippingCostAudit";
import { Profile } from "pages/profile/profile/profile";
function App() {
    var _useState = _sliced_to_array(useState(1), 2), selectbranchID = _useState[0], setSelectBranchID = _useState[1];
    var isLoading = useGlobalLoaderContext().isLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    useEffect(function() {
        console.log("env", env.REACT_APP_ENV);
        console.log("domain-api", domain);
        console.log("version", VER);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isLoading && /*#__PURE__*/ _jsx(GlobalLoader, {}),
            /*#__PURE__*/ _jsx(GlobalModal, {
                show: modalObj.visible,
                title: modalObj.title,
                subTitle: modalObj.subTitle,
                btnText: modalObj.btnText,
                onHide: function() {
                    return setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                        visible: false
                    }));
                }
            }),
            /*#__PURE__*/ _jsxs(Routes, {
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password",
                        element: /*#__PURE__*/ _jsx(Resetpassword, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password/success",
                        element: /*#__PURE__*/ _jsx(Resetpasswordsuccess, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(PublicRoutes, {}),
                        children: /*#__PURE__*/ _jsx(Route, {
                            path: "/login",
                            element: /*#__PURE__*/ _jsx(Login, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(ProtectedRoutes, {}),
                        children: /*#__PURE__*/ _jsxs(Route, {
                            path: "/",
                            element: /*#__PURE__*/ _jsx(Layout, {
                                setSelectBranchID: setSelectBranchID,
                                selectbranchID: selectbranchID
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps",
                                    element: /*#__PURE__*/ _jsx(Emp, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/create",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission",
                                    element: /*#__PURE__*/ _jsx(EmpPermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/create",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/setting/permission",
                                    element: /*#__PURE__*/ _jsx(Permission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/setting/permission/create",
                                    element: /*#__PURE__*/ _jsx(PermissionCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/setting/permission/edit/:dataId",
                                    element: /*#__PURE__*/ _jsx(PermissionCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/profile",
                                    element: /*#__PURE__*/ _jsx(Profile, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor",
                                    element: /*#__PURE__*/ _jsx(Distributor, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributorgroup",
                                    element: /*#__PURE__*/ _jsx(DistributorGroup, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/create",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/edit/:supID",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition",
                                    element: /*#__PURE__*/ _jsx(PRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/create",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/edit/:prID",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/orders",
                                    element: /*#__PURE__*/ _jsx(POList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/create",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/edit/:poID",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt",
                                    element: /*#__PURE__*/ _jsx(GRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(GoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor",
                                    element: /*#__PURE__*/ _jsx(CreditorList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor/goods-receipt/:dataID",
                                    element: /*#__PURE__*/ _jsx(CheckGoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expenses",
                                    element: /*#__PURE__*/ _jsx(ExpenseList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/supplier",
                                    element: /*#__PURE__*/ _jsx(ReportBuySupplier, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/order",
                                    element: /*#__PURE__*/ _jsx(ReportBuyOrder, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/po-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyPoItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/gr-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyGrItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/financial/gr-item-expense",
                                    element: /*#__PURE__*/ _jsx(ReportGrItemExpense, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/maps",
                                    element: /*#__PURE__*/ _jsx(ReportMaps, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/appointment",
                                    element: /*#__PURE__*/ _jsx(ReportAppointment, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_partner",
                                    element: /*#__PURE__*/ _jsx(ManagePartner, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_partner/view/:partnerId",
                                    element: /*#__PURE__*/ _jsx(ManagePartnerView, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_products",
                                    element: /*#__PURE__*/ _jsx(ManageProducts, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_products/datalist/:partnerId",
                                    element: /*#__PURE__*/ _jsx(ManageProductsDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_products/view/:partnerId",
                                    element: /*#__PURE__*/ _jsx(ManageProductsView, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_contract/new",
                                    element: /*#__PURE__*/ _jsx(ContractNew, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_contract/new/create",
                                    element: /*#__PURE__*/ _jsx(ContractNewCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_contract/new/edit/:contractID",
                                    element: /*#__PURE__*/ _jsx(ContractNewCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_contract/attach",
                                    element: /*#__PURE__*/ _jsx(ContractAttach, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/quotation",
                                    element: /*#__PURE__*/ _jsx(Quotation, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/quotation/create",
                                    element: /*#__PURE__*/ _jsx(QuotationCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/quotation/edit/:quoteId",
                                    element: /*#__PURE__*/ _jsx(QuotationCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/quotation/contract_create/:contractId",
                                    element: /*#__PURE__*/ _jsx(QuotationByContract, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing",
                                    element: /*#__PURE__*/ _jsx(Billing, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing/create",
                                    element: /*#__PURE__*/ _jsx(BillingCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(BillingCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing/quotation/edit/:poID",
                                    element: /*#__PURE__*/ _jsx(BillingCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/invoice",
                                    element: /*#__PURE__*/ _jsx(Invoice, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/invoice/create",
                                    element: /*#__PURE__*/ _jsx(InvoiceManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/invoice/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(InvoiceManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/branch",
                                    element: /*#__PURE__*/ _jsx(Branch, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/branch/manage/:dataID",
                                    element: /*#__PURE__*/ _jsx(BranchManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/promotion",
                                    element: /*#__PURE__*/ _jsx(Promotion, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/promotion/manage",
                                    element: /*#__PURE__*/ _jsx(PromotionManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/promotion/manage/:dataID",
                                    element: /*#__PURE__*/ _jsx(PromotionManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/clbook/catalog/:dataID",
                                    element: /*#__PURE__*/ _jsx(Catalog, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/clbook/catalog/:dataID/action/:actionID",
                                    element: /*#__PURE__*/ _jsx(CatalogAction, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/clbook",
                                    element: /*#__PURE__*/ _jsx(ClBook, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage/stock-count",
                                    element: /*#__PURE__*/ _jsx(StockCountList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage/stock-count/:roundId",
                                    element: /*#__PURE__*/ _jsx(StockCountEdit, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/clbook/catalog/:dataID/manage",
                                    element: /*#__PURE__*/ _jsx(CatalogManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/brand",
                                    element: /*#__PURE__*/ _jsx(Brand, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop",
                                    element: /*#__PURE__*/ _jsx(Shop, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/product-ban",
                                    element: /*#__PURE__*/ _jsx(ShopProductBan, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/special-price",
                                    element: /*#__PURE__*/ _jsx(ShopSpecialPrice, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/manage",
                                    element: /*#__PURE__*/ _jsx(ShopManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/manage/:shopId",
                                    element: /*#__PURE__*/ _jsx(ShopManageDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/manage/:shopId/branch",
                                    element: /*#__PURE__*/ _jsx(ShopManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shop/manage/:shopId/branch/:branchId",
                                    element: /*#__PURE__*/ _jsx(ShopManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/setting/master",
                                    element: /*#__PURE__*/ _jsx(SettingsMaster, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_user",
                                    element: /*#__PURE__*/ _jsx(SetUser, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_user/manage",
                                    element: /*#__PURE__*/ _jsx(SetUserManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage_user/manage/:dataID",
                                    element: /*#__PURE__*/ _jsx(SetUserManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/import/invoice/mt",
                                    element: /*#__PURE__*/ _jsx(ImportInvoiceMt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/import/invoice/tt",
                                    element: /*#__PURE__*/ _jsx(ImportInvoiceTt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/import/product/mt",
                                    element: /*#__PURE__*/ _jsx(ImportProductsMt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/import/product/tt",
                                    element: /*#__PURE__*/ _jsx(ImportProductsTt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation",
                                    element: /*#__PURE__*/ _jsx(ReportReservation, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/manage/reservation",
                                    element: /*#__PURE__*/ _jsx(ReservationManagement, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation/wait-delivery",
                                    element: /*#__PURE__*/ _jsx(ReportReservationWaitDelivery, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation/product-check/:reportId",
                                    element: /*#__PURE__*/ _jsx(ProductCheck, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation/edit/:reportId/:typeShop",
                                    element: /*#__PURE__*/ _jsx(ManageReservation, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation/view/:reportId",
                                    element: /*#__PURE__*/ _jsx(ViewReservation, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/productlist",
                                    element: /*#__PURE__*/ _jsx(ProductList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/productlist/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(ProductUpdate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/productlist/edit/:dataID/:view",
                                    element: /*#__PURE__*/ _jsx(ProductUpdate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shopvisit",
                                    element: /*#__PURE__*/ _jsx(ShopVisitList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shopvisit/manage",
                                    element: /*#__PURE__*/ _jsx(ShopVisitManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shopvisit/manage/:dataID",
                                    element: /*#__PURE__*/ _jsx(ShopVisitManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/shopvisit/manage/:dataID/:view",
                                    element: /*#__PURE__*/ _jsx(ShopVisitManage, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpurchasebrand",
                                    element: /*#__PURE__*/ _jsx(ReportPurchaseByBrand, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpurchasebrand/:dateVal/:brandName/:detailID",
                                    element: /*#__PURE__*/ _jsx(ReportPurchaseByBrandDetail, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpurchasependingconfirm",
                                    element: /*#__PURE__*/ _jsx(ReportPurchasePendingConfirm, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpurchaseproduct",
                                    element: /*#__PURE__*/ _jsx(ReportPurchaseByProduct, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportreservationbysku",
                                    element: /*#__PURE__*/ _jsx(ReportReservationBySku, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation-performance-monthly",
                                    element: /*#__PURE__*/ _jsx(ReportReservationPerformanceMonthly, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation-work-tracking",
                                    element: /*#__PURE__*/ _jsx(ReportReservationWorkTracking, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/sku-actual-delivery-monthly",
                                    element: /*#__PURE__*/ _jsx(ReportSkuActualDeliveryMonthly, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/sku-gift-monthly",
                                    element: /*#__PURE__*/ _jsx(ReportSkuGiftMonthly, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/sku-actual-delivery-monthly-by-shop",
                                    element: /*#__PURE__*/ _jsx(ReportSkuActualDeliveryMonthlyByShop, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reservation-duration",
                                    element: /*#__PURE__*/ _jsx(ReportReservationDuration, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsalesnewstore",
                                    element: /*#__PURE__*/ _jsx(ReportSalesNewStore, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpartner",
                                    element: /*#__PURE__*/ _jsx(ReportPartner, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsku",
                                    element: /*#__PURE__*/ _jsx(ReportSku, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsalesnewstore/detail/:dateMonth/:saleId",
                                    element: /*#__PURE__*/ _jsx(ReportSalesNewStoreDetail, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportreserve",
                                    element: /*#__PURE__*/ _jsx(ReportReserve, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportreserveday",
                                    element: /*#__PURE__*/ _jsx(ReportReserveDay, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportskuday",
                                    element: /*#__PURE__*/ _jsx(ReportSkuDay, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportpartnerday",
                                    element: /*#__PURE__*/ _jsx(ReportPartnerDay, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsalevisitandreserve",
                                    element: /*#__PURE__*/ _jsx(ReportSaleVisitAndReserve, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsalevisitandreservebysale",
                                    element: /*#__PURE__*/ _jsx(ReportSaleVisitAndReserveBySale, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportsaleintendantbranch",
                                    element: /*#__PURE__*/ _jsx(ReportSaleIntendantBranch, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportstorevisitappointment",
                                    element: /*#__PURE__*/ _jsx(ReportStoreVisitAppointment, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportstorevisitappointment/detail/:dateMonth/:saleId",
                                    element: /*#__PURE__*/ _jsx(ReportStoreVisitAppointmentDetail, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reportbrandsummary",
                                    element: /*#__PURE__*/ _jsx(ReportBrandSummary, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/salebystore/mt",
                                    element: /*#__PURE__*/ _jsx(ReportSalesByStoreMt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/salebystore/tt",
                                    element: /*#__PURE__*/ _jsx(ReportSalesByStoreTt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/salebyproduct/mt",
                                    element: /*#__PURE__*/ _jsx(ReportSalesByProductMt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/salebyproduct/tt",
                                    element: /*#__PURE__*/ _jsx(ReportSalesByProductTt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/reserveproductsummary",
                                    element: /*#__PURE__*/ _jsx(ReportReserveProductSummary, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/product-not-ready-delivery",
                                    element: /*#__PURE__*/ _jsx(ReportProductNotReadyDelivery, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/shipping-cost-audit",
                                    element: /*#__PURE__*/ _jsx(ReportShippingCostAudit, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/dashboard",
                                    element: /*#__PURE__*/ _jsx(Dashboard, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "*",
                        element: /*#__PURE__*/ _jsx(NotFoundPage, {})
                    })
                ]
            })
        ]
    });
}
function Home() {
    return /*#__PURE__*/ _jsx("div", {});
}
function Layoutadmin() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "page",
        children: [
            /*#__PURE__*/ _jsx(Layout, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "main-content app-content"
            })
        ]
    });
}
export default App;
